import { createContext, type PropsWithChildren, useContext } from 'react'

export type UserProviderProps = {
  userName: string
}

type UserContextType = UserProviderProps

const UserContext = createContext<UserContextType>({
  userName: '',
})

export function useUser () {
  return useContext(UserContext)
}

export default function UserProvider ({ userName, children }: PropsWithChildren<UserProviderProps>) {
  return (
    <UserContext.Provider value={{ userName }}>
      {children}
    </UserContext.Provider>
  )
}
